/*==========DO NOT CHANGE MANUALY =============*/
if(typeof jQueryETS !== 'undefined'){
	jQueryETS(document).ready(ETS_SOCIAL_LOGIN_FUNC);
}
else{
	var ETS_SOCIAL_LOGIN_INTERVAL =  setInterval(function(){
		if(typeof jQueryETS !== 'undefined'){
			jQueryETS(document).ready(ETS_SOCIAL_LOGIN_FUNC);
			clearInterval(ETS_SOCIAL_LOGIN_INTERVAL);
		}
	}, 200);
}


 function ETS_SOCIAL_LOGIN_FUNC(jQueryETS) {
	var etsSocialLogin = {
		showLoginButtons: function(){
			if (window.location.href.search('/account/login') !== -1 && ETS_SN_CONFIG.config.login_page.active){
				jQueryETS('input[name="customer[email]"]').closest('form').after('<div class="ets-social-login--position '+(ETS_SN_CONFIG.config.login_page.hide_on_mobile ? 'ets-socal-login--hide-on-mobile' : '')+'"><div class="ets-social-login-or"><span>Or</span></div>' + etsSocialLogin.generateSNButtons(ETS_SN_CONFIG.config.login_page) + '</div>');
			}
			if (window.location.href.search('/account/register') !== -1 && ETS_SN_CONFIG.config.register_page.active){
				jQueryETS('input[name="customer[email]"]').closest('form').after('<div class="ets-social-login--position '+(ETS_SN_CONFIG.config.register_page.hide_on_mobile ? 'ets-socal-login--hide-on-mobile' : '')+'"><div class="ets-social-login-or"><span>Or</span></div>' + etsSocialLogin.generateSNButtons(ETS_SN_CONFIG.config.register_page) + '</div>');
			}
			
			if (ETS_SN_CONFIG.config.login_popup.active && ETS_SN_CONFIG.config.login_popup.sn_use){
				var socials = ETS_SN_CONFIG.config.login_popup.nets;
				var popup_html = '';
				var classBtn = '';
				if (ETS_SN_CONFIG.config.login_popup.display_title){
					classBtn += ' btn-has-title';
				}
				if (ETS_SN_CONFIG.config.btn_rouned){
					classBtn += ' btn-rounded';
				}
				if (ETS_SN_CONFIG.config.btn_size){
					switch (ETS_SN_CONFIG.config.btn_size) {
						case 'small':
							classBtn += ' btn-small';
							break;
						case 'large':
							classBtn += ' btn-large';
							break;
					}
				}
				if (ETS_SN_CONFIG.config.login_popup.popup_type == 'click'){
					popup_html += '<div class="ets-social-login--overlay-popup">';
				}
				 popup_html += '<div class="ets-social-login--popup-login" id="ets-social-login--popup-login">';
					popup_html += '<div class="popup-inner">';
						popup_html += '<div class="popup-social-login">';
				popup_html += '<div class="popup-title">' + ETS_SN_CONFIG.config.login_popup.login_title + (ETS_SN_CONFIG.config.login_popup.popup_type == 'click' ? '<span class="close-popup"></span>' : '' )+'</div>';
							popup_html += '<div class="popup-sn-buttons">';
							for (var i = 0; i < socials.length; i++) {
								popup_html += '<a href="javascript:void(0)" title="'+socials[i].name+'" class="ets-social-login--btn js-ets-social-login--btn btn-'+socials[i].provider.toLowerCase()+' '+classBtn+'" data-provider="'+socials[i].provider+'"><i class="icon-sn icon-btn-'+socials[i].provider.toLowerCase()+'"></i>'+(ETS_SN_CONFIG.config.login_popup.display_title ? '<span class="sn-title">'+socials[i].name+'</span>' : '')+'</a>';
							}
							popup_html += '</div>';
					popup_html += '<div class="popup-desc">' + ETS_SN_CONFIG.config.login_popup.login_desc+'</div>';
						popup_html += '</div>';
						popup_html += '<div class="ets-social-login-or"><span>Or</span></div>';
						popup_html += '<div class="popup-normal-login">';
							popup_html += '<div class="popup-form">';
								popup_html += '<form action="/account/login" method="POST" class="form-login">';
									popup_html += '<div class="form-error"></div>';
									popup_html += '<div class="input-box">';
										popup_html += '<label class="input-label">Email</label>';
										popup_html += '<input type="email" required class="input-field" name="customer[email]">';
									popup_html += '</div>';
									popup_html += '<div class="input-box">';
										popup_html += '<label class="input-label">Password</label>';
										popup_html += '<input type="password" required class="input-field" name="customer[password]">';
									popup_html += '</div>';
									popup_html += '<div class="input-box text-center">';
										popup_html += '<button class="btn js-btn-login" type="submit">Login</button>';
									popup_html += '</div>';
									popup_html += '<div class="link-actions">';
										popup_html += '<a href="#recover" class="ets-social-login--link-recover">Forgot your password?</a>';
										popup_html += '<a href="/account/register" class="js-link-register">Create account</a>';
									popup_html += '</div>';
								popup_html += '</form>';
								popup_html += '<form action="/account/recover" method="POST" class="form-recover hidden">';
									popup_html += '<div class="recover-desc">We will send you an email to reset your password.</div>';
									popup_html += '<div class="input-box">';
										popup_html += '<label class="input-label">Email</label>';
										popup_html += '<input type="email" required class="input-field" name="email">';
									popup_html += '</div>';
									popup_html += '<div class="input-box text-center">';
										popup_html += '<button class="btn js-btn-reset-pwd" type="submit">Reset password</button>';
									popup_html += '</div>';
									popup_html += '<div class="input-box">';
										popup_html += '<a href="#" class="ets-social-login--cancel-recover">Cancel</a>';
									popup_html += '</div>';
								popup_html += '</form>';
							popup_html += '</div>';
						popup_html += '</div>';
					popup_html += '</div>';
				popup_html += '</div>';
				if (ETS_SN_CONFIG.config.login_popup.popup_type == 'click'){
					popup_html += '</div>'; //close tag ets-social-login--overlay-popup
				}
				if(jQueryETS('a[href*="/account"]').length && jQueryETS('.ets-social-login--customer_logged_in').length == 0){
					jQueryETS('a[href*="/account"]').each(function(index, el) {
						jQueryETS(this).addClass('ets-social-login--relative ' + (ETS_SN_CONFIG.config.login_popup.popup_type == 'hover' ? 'ets-social-login--popup-hover' : 'ets-social-login--popup-click')+(ETS_SN_CONFIG.config.login_popup.hide_on_mobile ? ' ets-social-login--hide-on-mobile' : ''));
						jQueryETS(this).append(popup_html);

						if(ETS_SN_CONFIG.config.login_popup.popup_type == 'hover'){
							jQueryETS(this).find('.ets-social-login--popup-login').css('top', (jQueryETS(this).outerHeight() - 10)+'px');
						}
					});
					
				}
			}

			if (ETS_SN_CONFIG.config.embedded_code.active && !jQueryETS('.ets-social-login--customer_logged_in').length){
				if(jQueryETS('.ets-social-login--position.generated').length){
					jQueryETS('.ets-social-login--position.generated').each(function() {
						if (jQueryETS(this).attr('data-sn_use')){
							var config = {
								display_title: jQueryETS(this).attr('data-display_title') == '1' ? 1 : 0,
								btn_rounded: jQueryETS(this).attr('data-btn_rounded') == '1' ? 1 : 0,
								btn_size: jQueryETS(this).attr('data-btn_size'),
								login_title: jQueryETS(this).attr('data-login_title'),
								login_desc: jQueryETS(this).attr('data-login_desc'),
								hide_one_mobile: jQueryETS(this).attr('data-hide_one_mobile') == '1' ? 1 : 0,
								sn_use: jQueryETS(this).attr('data-sn_use'),
							}
							var nets = [];
							var dataNames = jQueryETS(this).attr('data-names');
							var dataProviders = config.sn_use.split(',');
							jQueryETS.each(dataNames.split(','), function (i, el) {
								nets.push({
									name: el,
									provider: dataProviders[i]
								});
							});
							config.nets = nets;
							if (config.hide_on_mobile) {
								jQueryETS(this).addClass('ets-social-login--hide-on-mobile');
							}
							jQueryETS(this).html(etsSocialLogin.generateSNButtons(config));
						}
						
					});
				}
			}
		},
		generateSNButtons: function(config){
			var socials = config.nets;
			var classBtn = '';
			if(config.display_title){
				classBtn += ' btn-has-title';
			}
			if(config.btn_rounded){
				classBtn += ' btn-rounded';
			}
			if(config.btn_size){
				switch (config.btn_size) {
					case 'small':
						classBtn += ' btn-small';
						break;
					case 'large':
						classBtn += ' btn-large';
						break;
				}
			}
			var button_html = '';
			button_html += '<div class="ets-social-login-title">'+(config.login_title)+'</div>';
			button_html += '<div class="ets-social-login-group-btn">';
			for (var i = 0; i < socials.length; i++) {
				button_html += '<a href="javascript:void(0)" title="'+socials[i].name+'" class="ets-social-login--btn js-ets-social-login--btn btn-'+socials[i].provider.toLowerCase()+' '+classBtn+'" data-provider="'+socials[i].provider+'"><i class="icon-sn icon-btn-'+socials[i].provider.toLowerCase()+'"></i>'+(config.display_title ? '<span class="sn-title">'+socials[i].name+'</span>' : '')+'</a>';
			}
			button_html += '</div>';
			button_html += '<div class="ets-social-login-desc">'+(config.login_desc)+'</div>';
			button_html += '<div class="clearfix"></div>';

			return button_html;
		},
		etsLogin: function(email, password){
			var data = {
		    	'customer[email]': email,
		    	'customer[password]': password,
			    form_type: 'customer_login',
			    	utf8: '✓'
			  	};

			  var promise = jQueryETS.ajax({
			    url: '/account/login',
			    method: 'post',
			    data: data,
			    dataType: 'html',
			    async: true
			  });

		  	return promise;
		},
		getShop: function(){
			if(typeof ETS_SOLO_DOMAIN_SHOP !== 'undefined' && ETS_SOLO_DOMAIN_SHOP){
				return ETS_SOLO_DOMAIN_SHOP;
			}
			return window.location.hostname.replace('wwww.', '');
		},
		getQueryParam: function(url, key){
			urlObj = new URL(url);
			return urlObj.searchParams.get(key);
		},
		getDataLogin: function(u,v){
			jQueryETS.ajax({
				url: ETS_SN_CONFIG.base_path+"/apps/customer/auth",
				type: 'POST',
				dataType: 'json',
				data:{
					u:u,
					v:v
				},
				success: function(r){
					if(r){
						etsSocialLogin.doLogin(r, 1);
					}
				}
			});
		},
		updateDataLogin: function(e){
			jQueryETS.ajax({
				url: ETS_SN_CONFIG.base_path+"/apps/customer/update",
				type: 'POST',
				dataType: 'json',
				data:{
					e:e,
					s: etsSocialLogin.getShop()
				},
				success: function(r){
					if(r){
						etsSocialLogin.doLogin(r,2);
					}
				}
			})
		},
		doLogin: function(r, c){
			etsSocialLogin.etsLogin(r.u, r.v).done(function (html){
				if (html.indexOf('Invalid login credentials') !== -1) {
					if(c==1 || c==2){
						etsSocialLogin.updateDataLogin(r);
						if(c==2){
							window.opener.location.href = '/account';
							window.close();
						}
					}
					else{
						window.opener.location.href = '/account';
						window.close();
					}
				 
			  	} else {
			  		if(localStorage.getItem('ets_social_login_c3')){
						window.opener.location.href = '/discount/'+localStorage.getItem('ets_social_login_c3');
					}
					else{
						window.opener.location.href = '/account';
					}
					window.close();
			  	}
			});
		},

		validateEmail: function(email){
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    	return re.test(String(email).toLowerCase());
		},
		showPopupDiscount: function(code, reduction, from, to){
			var popup_content = ETS_SN_CONFIG.popup_discount_content;
				popup_content = popup_content.replace('[discount_code]', '<span class="box_discount_code"><i class="discount_code_before"></i><span class="outer_input_code"><span class="tooltip_copied">Copied</span><span class="discount_code">'+code+'</span></span></span>');
				if(reduction){
					popup_content = popup_content.replace('[reduction]', '<strong>'+reduction+'</strong>');
				}
				if(from){
					popup_content = popup_content.replace('[discount_from]', '<strong>'+from+'</strong>');
				}
				if(to){
					popup_content = popup_content.replace('[discount_to]', '<strong>'+to+'</strong>');
				}
				
			var popup_html = '<div class="ets-social-login--popup-discount" id="ets-social-login--popup-discount">'
				+ '<div class="popup-content">'
				    +  '<div class="popup-header">'
				      	+ ' <span class="close">&times;</span>'
				      	// + '<h2 class="popup-title">Modal Header</h2>'
				    +  '</div>'
				    +  '<div class="popup-body">'
				    	+ '<p class="discount-text text-large"><strong>'+ETS_SN_CONFIG.popup_discount_title+'</strong></p>'
				      	+ popup_content
				    +  '</div>'
				 +  '</div>'
			+ '</div>';

			jQueryETS('body').append(popup_html);
			jQueryETS('.ets-social-login--popup-discount').addClass('open-popup');

		},
		formatDate: function(strDate){
			var date = new Date(strDate);
			var day = date.getDay();
			if(day < 10){
				day = '0'+day;
			}
			var month = date.getMonth()+1;
			if(month < 10){
				month = '0'+month;
			}
			return day+'-'+month+'-'+date.getFullYear();
		}
	};
	/*===========*/
	if(typeof ETS_SN_CONFIG == 'undefined'){
		return;
	}
	//dc
	if(etsSocialLogin.getQueryParam(window.location.href, 'c3')){
		localStorage.setItem('ets_social_login_c3', etsSocialLogin.getQueryParam(window.location.href, 'c3'));
		localStorage.setItem('ets_social_login_c31', etsSocialLogin.getQueryParam(window.location.href, 'c31'));
		localStorage.setItem('ets_social_login_c32', etsSocialLogin.getQueryParam(window.location.href, 'c32'));
		localStorage.setItem('ets_social_login_c33', etsSocialLogin.getQueryParam(window.location.href, 'c33'));
	}
	var appETSSocialLoginInstalled = 0;
	jQueryETS('script').each(function() {
		if(jQueryETS(this).text().indexOf('asyncLoad') != -1 && jQueryETS(this).text().indexOf('ets_social_login_init.js?') != -1){
			appETSSocialLoginInstalled = 1;
			return false;
		}
	});
	if(!appETSSocialLoginInstalled){
		return;
	}
	//Show social login button
	etsSocialLogin.showLoginButtons();
	jQueryETS(document).on('click', '.js-ets-social-login--btn', function(event) {
		event.preventDefault();
		localStorage.setItem('ets_social_login_logging', 1);
		var provider = jQueryETS(this).attr('data-provider');
		var popupWidth = 500;
		var popupHeight = 500;
		if(jQueryETS(window).width() <768){
			popupWidth = 300;
		}
		//Allow for borders.
		var leftPosition = (window.screen.width / 2) - ((popupWidth / 2) + 10);
	    //Allow for title and status bars.
	    var topPosition = (window.screen.height / 2) - ((popupHeight / 2) + 50);
		ets_solo_win = window.open(ETS_SN_CONFIG.base_path+'/apps/oauth?provider='+provider+'&shop='+etsSocialLogin.getShop(), "", "width="+popupWidth+",height="+popupHeight+",screenX=" + leftPosition + ",screenY="
    + topPosition + "");
	});

	if(etsSocialLogin.getQueryParam(window.location.href, 'u1')){
		etsSocialLogin.getDataLogin( etsSocialLogin.getQueryParam(window.location.href, 'u1'),etsSocialLogin.getQueryParam(window.location.href, 'u2'));
	}

	if(etsSocialLogin.getQueryParam(window.location.href, 'etsSoloDiscount') && localStorage.getItem('ets_social_login_logging')){
		localStorage.setItem('ets_social_login_c3', etsSocialLogin.getQueryParam(window.location.href, 'etsSoloDiscount'));
		localStorage.setItem('ets_social_login_c31', etsSocialLogin.getQueryParam(window.location.href, 'etsSoloDiscountReduction'));
		localStorage.setItem('ets_social_login_c32', etsSocialLogin.getQueryParam(window.location.href, 'etsSoloDiscountFrom'));
		localStorage.setItem('ets_social_login_c33', etsSocialLogin.getQueryParam(window.location.href, 'etsSoloDiscountTo'));
	}

	if(window.location.href.search('/account') !== -1 && window.location.href.search('/account/login') === -1 && window.location.href.search('account/register') === -1){
		if(window.opener){
			if(localStorage.getItem('ets_social_login_c3')){
				window.opener.location.href = '/discount/'+localStorage.getItem('ets_social_login_c3');
			}
			else{
				window.opener.location.href = '/account';
			}
			window.close();
		}
		
	}
	
	if(!window.opener){
		if(localStorage.getItem('ets_social_login_c3')){
			setTimeout(function(){
				etsSocialLogin.showPopupDiscount(localStorage.getItem('ets_social_login_c3'), 
					localStorage.getItem('ets_social_login_c31'), 
					localStorage.getItem('ets_social_login_c32'),
					localStorage.getItem('ets_social_login_c33'));

				localStorage.removeItem('ets_social_login_c3');
				if(localStorage.getItem('ets_social_login_c31')){
					localStorage.removeItem('ets_social_login_c31')
				}
				if(localStorage.getItem('ets_social_login_c32')){
					localStorage.removeItem('ets_social_login_c32')
				}
				if(localStorage.getItem('ets_social_login_c33')){
					localStorage.removeItem('ets_social_login_c33')
				}
			}, 2000);
		}
	}
	jQueryETS(document).on('click', '.ets-social-login--popup-click', function(event) {
		if(jQueryETS(this).hasClass('ets-social-login--hide-on-mobile') && $(window).width() <= 768){
			return true;
		};
		var target = jQueryETS(event.target);
		if(!jQueryETS(this).find('.ets-social-login--overlay-popup').hasClass('open-popup')){
			jQueryETS(this).find('.ets-social-login--overlay-popup').addClass('open-popup');
			if(!jQueryETS(this).find('.ets-social-login--popup-login').first().hasClass('open')){
				jQueryETS(this).find('.ets-social-login--popup-login').first().addClass('open');
			}
		}
		else{
			if(!target.is('.ets-social-login--popup-login')){
				jQueryETS(this).find('.ets-social-login--overlay-popup').removeClass('open-popup');
				jQueryETS(this).find('.ets-social-login--popup-login').removeClass('open');
			}
		}
		
		
		return false;
	});

	jQueryETS(document).on('click', '.ets-social-login--popup-click .close-popup', function(event) {
		jQueryETS(this).closest('.ets-social-login--popup-login').removeClass('open');
		jQueryETS('.ets-social-login--overlay-popup').removeClass('open-popup');
		
		return false;
	});
	jQueryETS(document).on('keyup', function(event) {
		if(event.keyCode == 27){
			jQueryETS('.ets-social-login--popup-login').removeClass('open');
			jQueryETS('.ets-social-login--overlay-popup').removeClass('open-popup');
		}
	});

	jQueryETS(document).on('click', '.ets-social-login--popup-discount .discount_code', function(event) {
		event.preventDefault();
		var code = jQueryETS(this).html();
		var body = document.getElementsByTagName('body')[0];
		var inputCode = document.createElement('input');
		body.appendChild(inputCode);
		inputCode.setAttribute('value', code);
		inputCode.select();
		document.execCommand("copy");
		body.removeChild(inputCode);
		jQueryETS(this).closest('.outer_input_code').find('.tooltip_copied').show();
		var $this = jQueryETS(this);
		setTimeout(function(){
			$this.closest('.outer_input_code').find('.tooltip_copied').hide();
		}, 3000);
	});

	jQueryETS(document).on('mouseover', '.ets-social-login--popup-hover', function(event) {
		if (jQueryETS(this).hasClass('ets-social-login--hide-on-mobile') && $(window).width() <= 768) {
			return true;
		};
		if(!jQueryETS(this).find('.ets-social-login--popup-login').first().hasClass('open')){
			jQueryETS(this).find('.ets-social-login--popup-login').first().addClass('open');
		}
		return false;
	});
	jQueryETS(document).on('mouseleave', '.ets-social-login--popup-hover', function(event) {
		if (!jQueryETS(".ets-social-login--popup-login input").is(event.target) && jQueryETS("ets-social-login--popup-login input").has(event.target).length ===0)  {
	       jQueryETS(this).find('.ets-social-login--popup-login').first().removeClass('open');
	    }
		return false;
	});

	jQueryETS(document).on('click', '.ets-social-login--popup-login .ets-social-login--link-recover', function(event) {
		if(jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-recover').hasClass('hidden')){
			jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-recover').removeClass('hidden');
		}
		if(!jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-login').hasClass('hidden')){
			jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-login').addClass('hidden');
		}
	});
	jQueryETS(document).on('click', '.ets-social-login--popup-login .ets-social-login--cancel-recover', function(event) {
		if(!jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-recover').hasClass('hidden')){
			jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-recover').addClass('hidden');
		}
		if(jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-login').hasClass('hidden')){
			jQueryETS(this).closest('.ets-social-login--popup-login').find('.form-login').removeClass('hidden');
		}
	});
	jQueryETS(document).on('click', '.ets-social-login--popup-login', function(event) {
		return false;
	});

	jQueryETS(document).click(function(event) { 
	  var target = jQueryETS(event.target);
	  if(!target.closest('.ets-social-login--popup-login').length
	  	&& jQueryETS('.ets-social-login--popup-login').hasClass("open")) {
	    jQueryETS('.ets-social-login--popup-login').removeClass('open');
	  }        
	});

	//Login popup
	jQueryETS(document).on('click', '.ets-social-login--popup-login .js-btn-login', function(event) {
		
		var emailLogin = jQueryETS(this).closest('form').find('input[name="customer[email]"]').val();
		var pwdLogin = jQueryETS(this).closest('form').find('input[name="customer[password]"]').val();
		if(emailLogin && pwdLogin){
			jQueryETS(this).prop('disabled', true);
			var $this = jQueryETS(this);
			etsSocialLogin.etsLogin(emailLogin, pwdLogin).done(function(html){
				if (html.indexOf('Invalid login credentials') !== -1) {
					$this.closest('form').find('.form-error').html('Invalid login credentials');
				 
			  	} else {
			  		window.location.href = '/account';
			  	}
			  	$this.prop('disabled', false);
			});
		}
		else{
			$this.closest('form').find('.form-error').html('Email and password is required');
		}
		
	});

	//Recover popup

	jQueryETS(document).on('click', '.ets-social-login--popup-login .js-btn-reset-pwd', function(event) {
		
		var emailReset = jQueryETS(this).closest('form').find('input[name="email"]').val();
		if(emailReset){
			jQueryETS(this).prop('disabled', true);
			jQueryETS(this).closest('form').submit();
		}
		else{
			$this.closest('form').find('.form-error').html('Email is required');
		}
		
	});
	

	jQueryETS(document).on('click', '.ets-social-login--popup-login .js-link-register', function(event) {
		window.location.href = jQueryETS(this).attr('href');
	});

	jQueryETS(document).on('click', '#ets-social-login--popup-discount .close', function(event) {
		jQueryETS(this).closest('#ets-social-login--popup-discount').removeClass('open-popup');
	});

	jQueryETS(window).on('click', function(event) {
		 var target = jQueryETS(event.target);
		if (target.is('#ets-social-login--popup-discount')) {
	    	jQueryETS('#ets-social-login--popup-discount').removeClass('open-popup');
	  	}
	});
}





